import { Page } from '@ih/app/shared/apis/interfaces';

export class ShowDeleteConfirmationAction {
  public static readonly type =
    '[Project/Wiki/List] ShowDeleteConfirmationAction';
  constructor(public readonly page: Page) {}
}
